<template>
  <div>
    <!-- Filters -->
    <filters
      v-if="userRol.id==3"
      v-show="!errorContent.filters"
      :rol-filter.sync="configRequest.rolb"
      :grupo-filter.sync="configRequest.grupob"
      :status-filter.sync="configRequest.estadob"
      :rol-options="rolOptions"
      :grupo-options="grupoOptions"
      :status-options="statusOptions"
      :loader="loader.filters"
    />

    <!-- Table Container Card -->
    <b-card
      v-show="!errorContent.table"
      no-body
      class="mb-0"
    >
      <!-- Datos cargados -->
      <b-card-header class="pb-0">
        <b-card-title />
        <b-card-text class="font-small-2 mr-25 mb-0">
          Datos cargados <b>{{ updatedAt }}</b>
        </b-card-text>
      </b-card-header>

      <div class="m-2">
        <b-row class="m-2">
          <b-col
            cols="12"
          >
            <selectplan
              :filtrado="true"
              @selectedplan="$event ? idplan = $event : idplan = null; loadusuarios()"
            />
          </b-col>
        </b-row>
      </div>
      <!-- Table Top -->
      <div class="m-2">
        <b-row>
          <!-- Cantidad de elementos por página -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <span>Mostrar</span>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
          </b-col>

          <!-- Buscador -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-input-group class="input-group-merge">
                <b-input-group-prepend is-text>
                  <feather-icon
                    :class="{ 'text-danger cursor-pointer': searchQuery != '' }"
                    :icon="searchQuery != '' ? 'XIcon' : 'SearchIcon'"
                    @click="searchQuery != '' ? searchQuery = '' : ''"
                  />
                </b-input-group-prepend>
                <b-form-input
                  v-model="searchQuery"
                  placeholder="Buscar"
                />
              </b-input-group>
            </div>
          </b-col>
        </b-row>
      </div>

      <b-overlay
        rounded="sm"
        :show="isBusyTable"
        opacity="0"
      >
        <b-table
          ref="refDataListTable"
          class="position-relative"
          empty-text="No se encontraron resultados"
          primary-key="id_table_user"
          responsive
          show-empty
          striped
          :items="fetchData"
          :fields="tableColumns"
          :sort-desc.sync="isSortDirDesc"
          :sort-by.sync="sortBy"
        >
          <!-- Column: User -->
          <template #cell(cuenta)="data">
            <b-media
              v-if="data.item.persona.length"
              vertical-align="center"
            >
              <template>
                <b-avatar
                  size="42"
                  :text="avatarText(data.item.persona[0].nombre)"
                  :variant="`light-${resolveUserGrupoVariant(data.item.grupos[0].grupo)}`"
                />
              </template>
              <b-link
                :class="`font-weight-bold d-block text-nowrap text-${resolveUserGrupoVariant(data.item.grupos[0].grupo)}`"
                :to="{ name: 'detalle-usuario', params: { id: data.item.persona[0].fk } }"
              >
                {{ data.item.persona[0].nombre }}
              </b-link>
              <small class="text-muted">tel: <b>{{ data.item.persona[0].telefono }}</b></small>
              <p><small class="text-muted">email: <b>{{ data.item.persona[0].email }}</b></small></p>
              <div
                v-for="(planx, index) in data.item.planes"
                :key="`plan-${index}-planes`"
              > <small class="text-muted"><b> - {{ planx.nombre_plan }}</b></small>

              </div>
            </b-media>
          </template>
          <!-- Column: Grupo -->
          <template #cell(grupo)="data">
            <div
              v-for="(grupousuario, index ) in data.item.grupos"
              :key="`grupos-${index}-persona`"
            >
              <div :class="`d-flex align-items-center text-${resolveUserGrupoVariant(grupousuario.grupo)}`">
                <b>{{ grupousuario.grupo }}</b>
              </div>
            </div>
          </template>
          <!-- Column: estado -->
          <template #cell(estado)="data">

            <div
              v-for="(cuentausuario, index) in data.item.cuentas"
              :key="`cuenta-${index}-persona`"
            >
              <b>@{{ cuentausuario.cuenta }}</b>
              <b-badge
                pill
                :variant="`light-${resolveUserestadoVariant(cuentausuario.estado)}`"
                class="text-capitalize"
              >
                {{ cuentausuario.estado }}
              </b-badge>

            </div>
          </template>
          <!-- Column: Matricula -->
          <template #cell(matricula)="data">
            <div class="text-center">
              <b>{{ data.item.matricula }}</b>
            </div>
            <small
              v-if="data.item.matricula === null && data.item.grupos &&data.item.grupos[0].grupo != 'Alumno'"
              class="align-text-top text-secondary"
            >N/A</small>
            <small
              v-if="data.item.matricula === null && data.item.grupos && data.item.grupos[0].grupo === 'Alumno'"
              class="align-text-top text-secondary"
            >Falta matricula</small>
          </template>
          <!-- Column: rol -->
          <template
            #cell(rol)="data"
          >
            <div
              v-for="(rolusuario, index) in data.item.roles"
              :key="`roles-${index}-persona`"
            >
              <div class="text-nowrap">
                <feather-icon
                  v-if="rolusuario.rol != null"
                  :icon="resolveUserrolIcon(rolusuario.rol)"
                  size="18"
                  class="mr-50"
                  :class="`text-${resolveUserrolVariant(rolusuario.rol)}`"
                />
                <div
                  v-if="((data.item.empleado === null && data.item.grupos.length > 1) || (data.item.empleado === null && data.item.grupos.length === 1 && data.item.grupos[0].grupo != 'Alumno'))"
                >
                  <small>
                    <feather-icon
                      icon="AlertTriangleIcon"
                      size="14"
                      class="mr-50 text-danger"
                    />La relación empleado-rol,</small>
                  <br>
                  <small>no existe.</small>

                </div>
                <span class="align-text-top text-capitalize">{{ rolusuario.rol }}</span>
                <small
                  v-if="rolusuario.rol === null && data.item.grupos.length === 1 && data.item.grupos[0].grupo === 'Alumno'"
                  class="align-text-top text-secondary"
                >N/A</small>
              </div>
            </div>
          </template>

          <!-- Column: Opciones -->
          <template
            #cell(opciones)="data"
          >
            <div
              v-if="data.item.persona.length"
              class="text-nowrap text-center"
            >
              <!-- Detalle -->
              <b-link
                :to="{ name: 'detalle-usuario', params: { id: data.item.persona[0].fk } }"
                class="font-weight-bold text-secondary"
              >
                <feather-icon
                  :id="`usuario-row-${data.index}-ver-icon`"
                  icon="EyeIcon"
                  class="text-primary cursor-pointer mr-1"
                  size="16"
                />
              </b-link>
              <b-tooltip
                title="Ver registro"
                :target="`usuario-row-${data.index}-ver-icon`"
              />

              <!-- Editar -->
              <b-link
                v-if="userRol.id==3 || userRol.id ==2 || userRol.id ==11"
                :to="{ name: 'editar-usuario', params: { id: data.item.persona[0].fk } }"
                class="font-weight-bold text-secondary"
              >
                <feather-icon
                  :id="`usuario-row-${data.index }-editar-icon`"
                  icon="Edit3Icon"
                  class="cursor-pointer mr-1"
                  size="16"
                />
                <b-tooltip
                  title="Editar registro"
                  :target="`usuario-row-${data.index }-editar-icon`"
                />
              </b-link>
              <!-- Subir docs -->
              <b-link
                class="font-weight-bold text-secondary"
                @click="documentActive(data.item.persona[0])"
              >
                <feather-icon
                  :id="`usuario-row-${data.index}-subir-docs-icon`"
                  icon="UploadCloudIcon"
                  class="cursor-pointer mr-1"
                  size="16"
                />
                <b-tooltip
                  title="Subir Documentos"
                  :target="`usuario-row-${data.index}-subir-docs-icon`"
                />
              </b-link>
              <!-- Habilitar cuatrimestre, por el momento solo ROOT lo puede usar -->
              <b-link
                v-show="userRol.id==3"
                class="font-weight-bold text-secondary"
                @click="moodActive(data.item.persona[0])"
              >
                <feather-icon
                  :id="`usuario-row-${data.index}-enable-cuat-icon`"
                  icon="ShoppingCartIcon"
                  class="cursor-pointer"
                  size="16"
                />
                <b-tooltip
                  title="Habilitar cuatrimestre "
                  :target="`usuario-row-${data.index}-enable-cuat-icon`"
                />
              </b-link>
            </div>
          </template>
        </b-table>
      </b-overlay>
      <!-- Table's footer & pagination -->
      <div class="mx-2 mb-2">
        <b-row>
          <!-- Leyenda de cuantos elementos se muestran -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Mostrando {{ dataMeta.from }} a {{ dataMeta.to }} de {{ dataMeta.of }} registros</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >

            <b-pagination
              v-model="currentPage"
              :total-rows="totalItems"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>
        </b-row>
      </div>
    </b-card>

    <!-- modales -->
    <b-modal
      id="activeCuat"
      v-model="flagactivarmod"
      size="lg"
      no-close-on-backdrop
      hide-footer
      no-body
      @hide="clearselection()"
    >
      <b-container>
        <b-row>
          <b-col
            md="12"
            class="mb-2"
          >
            <b-card-title class="d-block text-center">
              ¡Cuidado!, use este modulo con precaución.
            </b-card-title>
            <b-card-sub-title class="mb-2">
              Por favor use esta opción con cuidado, ya que permite la activacion de periodos sin necesidad de registrar pagos.
            </b-card-sub-title>
            <b-card-text class="text-justify">
              Matricula: <code>{{ selectAlumno.matricula }}</code>
              <span> del alumn@ <b>{{ selectAlumno.nombre }}</b> </span>
              con correo: <code>{{ selectAlumno.email }}</code>
              <span> y telefono: {{ selectAlumno.telefono }}</span>
            </b-card-text>
          </b-col>
          <!-- kardex actual -->
          <b-col md="12">
            <h6>Periodos actualmente habilitados </h6>
            <b-form-group>
              <v-select
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="periodo"
                :options="kardexActual"
              >
                <template #no-options>
                  <em style="opacity: 0.5;">El alumno no tiene periodos activos</em>
                </template>
                <template #option="option">
                  <span class="CheckIcon" />
                  {{ option.nombre }} | {{ option.clave }} - [ {{ option.cobertura }} ]
                </template>
                <!-- Como se ve la opción seleccionada -->
                <template #selected-option="{ nombre, clave, cobertura }">
                  <div style="display: flex; align-items: baseline;">
                    <b>{{ nombre }} </b><em style="margin-left: .5rem;"> |  {{ clave }} - [ {{ cobertura }} ]  </em>
                  </div>
                </template>
              </v-select>
            </b-form-group>
          </b-col>
          <!-- Lista de planes  -->
          <b-col md="6">
            <h6 class="text-warning">
              Planes Seleccionables *
            </h6>
            <b-form-group>
              <v-select
                v-model="actplan"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :reduce="r => r.plan_id"
                label="nombre"
                :options="planes"
                @input="selecperiodo()"
              >
                <template #no-options>
                  <em style="opacity: 0.5;">No hay planes vinculados</em>
                </template>
              </v-select>
            </b-form-group>
          </b-col>
          <!-- Lista de Periodos -->
          <b-col md="6">
            <h6 class="text-warning">
              Periodos Seleccionables*
            </h6>
            <b-form-group>
              <v-select
                v-model="actperiodo"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :reduce="r => r.id"
                label="nombre"
                :options="periodos"
                @input="planxperiodo()"
              >
                <template #no-options>
                  <em style="opacity: 0.5;">No hay periodos disponibles</em>
                </template>
                <template #option="option">
                  <span class="CheckIcon" />
                  {{ option.nombre }} | {{ option.temporalidad }}
                </template>
                <!-- Como se ve la opción seleccionada -->
                <template #selected-option="{ nombre, temporalidad }">
                  <div style="display: flex; align-items: baseline;">
                    <b>{{ nombre }} </b><em style="margin-left: .5rem;"> |  {{ temporalidad }}   </em>
                  </div>
                </template>
              </v-select>
            </b-form-group>
          </b-col>
          <!-- materias -->
          <b-col
            v-show="materias.length > 0"
            md="12"
          >
            <h6>Cursos que se aplicaran </h6>
            <b-form-group>
              <b-list-group flush>
                <b-list-group-item
                  v-for="item in materias"
                  :key="item.materia"
                >
                  {{ item.clave }} | {{ item.nombre }}
                </b-list-group-item>
              </b-list-group>
            </b-form-group>
          </b-col>
          <b-col
            md="12"
            class="mt-2 mb-2"
          >
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              :disabled="(isActive)"
              block
              variant="primary"
              @click="activarCuatrimestre()"
            >
              <b-spinner
                v-show="flagproceder"
                small
                type="grow"
              />
              {{ (flagproceder) ? 'Trabajando...': 'Activar periodo' }}
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </b-modal>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BTable,
  BAvatar,
  BMedia,
  BBadge,
  BPagination,
  BCardHeader,
  BCardText,
  BCardTitle,
  BTooltip,
  BInputGroup,
  BInputGroupPrepend,
  BLink,
  BOverlay,
  BContainer,
  BButton,
  BSpinner,
  BCardSubTitle,
  BListGroup,
  BListGroupItem,
  VBModal,
  VBToggle,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store'
import {
  ref, onMounted, watch,
} from '@vue/composition-api'
import {
  lastUpdate, timestampToDate, nombreModalidad, avatarText,
} from '@core/utils/filter'
import {
  configTableUsuarios,
  useUsuariosCatalogos,
  fetchUsuarios,
} from '@/views/campus/usuarios/useUsuarios'
import { formhttp } from '@core/utils/utils'
import { useFillDataTable } from '@core/components/data-table/useFillDataTable'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { rolesActions } from '@core/mixins/account-data/roles'
import Ripple from 'vue-ripple-directive'
import hostname from '@core/utils/http/config-hostname'
import { useServicioEscolarCatalogos } from '@/views/campus/servicio-escolar/useServicioEscolar'
import selectplan from '@/views/components/select-plan.vue'
import Filters from './components/Filters.vue'

export default {
  components: {
    Filters,
    BCard,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BTable,
    BAvatar,
    BMedia,
    BCardHeader,
    BCardTitle,
    BCardText,
    BInputGroup,
    BInputGroupPrepend,
    BTooltip,
    BLink,
    BBadge,
    BPagination,
    vSelect,
    BOverlay,
    BContainer,
    BButton,
    BSpinner,
    BCardSubTitle,
    BListGroup,
    BListGroupItem,
    selectplan,
  },
  directives: {
    Ripple,
    'b-toggle': VBToggle,
    'b-modal': VBModal,
  },
  mixins: [rolesActions],
  setup() {
    const flagactivarmod = ref(false)
    const actplan = ref(0)
    const actperiodo = ref(0)
    const actpersonafk = ref(0)
    const flagproceder = ref(false)
    const isActive = ref(true)
    const selectAlumno = ref({})
    const { planxmtrl, periodosComprados } = useServicioEscolarCatalogos()
    const { ofertaacademica } = useServicioEscolarCatalogos()
    const { planselect } = useServicioEscolarCatalogos()
    const planes = ref([])
    const periodos = ref([])
    const kardexActual = ref([])
    const materias = ref([])
    const temporalidad = ref([])
    const toast = useToast()
    const updatedAt = ref(lastUpdate())
    const loader = ref({ filters: false })
    const errorContent = ref({ filters: false, table: false })
    const idsarray = ref([])
    const idplan = ref(null)
    const {
      tableColumns,
      resolveUserestadoVariant,
      resolveUserrolVariant,
      resolveUserGrupoVariant,
      resolveUserrolIcon,
    } = configTableUsuarios()
    const { configRequest } = fetchUsuarios(idplan)

    const {
      statusOptions, rolOptions, grupoOptions, rolOptionsPromise, grupoOptionsPromise,
    } = useUsuariosCatalogos()
    const {
      //* Fetching data
      fetchData, refetchData, refDataListTable,
      //* Pagination
      dataMeta,
      //* Table dynamic params
      dynamicParamRequest,
      //* Basic filters & pagination
      perPage, totalItems, currentPage, perPageOptions, searchQuery, sortBy, isSortDirDesc,
      //* Loader
      isBusyTable,
      //* Error
      errorRequest,
    } = useFillDataTable()
    isSortDirDesc.value = false
    //* Method to load filters, this makes promises, and wait to finish both of them to remove overlay
    const fetchCatalogosFilters = () => {
      loader.value.filters = true
      Promise.all([rolOptionsPromise, grupoOptionsPromise])
        .then(() => { loader.value.filters = false })
        .catch(error => {
          loader.value.filters = false
          errorContent.value.filters = true
          toast({
            component: ToastificationContent,
            props: {
              title: 'Error en petición [Catalogos de filtros]',
              text: `${error} Descuida, puedes seguir trabajando con la tabla de resultados, nosotros verémos la manera de solucionar el inconveniente ;)`,
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          },
          { timeout: 10000 })
        })
    }
    // show module for upload documents per user
    const documentActive = item => {
      const config = 'menubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes,width=700,height=800'
      const routeData = `${hostname().host}/app/usuarios/documentacion/${item.fk}/${item.matricula}`
      window.open(routeData, 'Configurar Facturacion', config)
    }

    // buscar cursos activos por mtrl
    const cursosActivos = mtrl => {
      periodosComprados(mtrl)
        .then(response => {
          kardexActual.value = response.cursando
        })
        .catch(error => {
          errorContent.value.filters = true
          toast({
            component: ToastificationContent,
            props: {
              title: 'Error en petición [Planes y periodos]',
              text: `${error} Intente de nuevo por favor.`,
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          },
          { timeout: 10000 })
        })
    }

    // busca planes que tiene activos y habilita la interfaz para lo nuevo.
    const moodActive = obj => {
      // valido si tiene matricula, puede ser un empleado
      if (obj.matricula != null) {
        flagactivarmod.value = true
        selectAlumno.value = obj
        actpersonafk.value = obj.persona_fk
        planxmtrl(obj.matricula)
          .then(response => {
            planes.value = response.datos
            loader.value.filters = false
            if (response.status === 200) {
              cursosActivos(obj.matricula)
            }
          })
          .catch(error => {
            loader.value.filters = false
            errorContent.value.filters = true
            toast({
              component: ToastificationContent,
              props: {
                title: 'Error en petición [Planes y periodos]',
                text: `${error} Intente de nuevo por favor.`,
                icon: 'AlertCircleIcon',
                variant: 'danger',
              },
            },
            { timeout: 10000 })
          })
      } else {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Atención',
            text: 'Matricula no encontrada',
            icon: 'FrownIcon',
            variant: 'error',
          },
        },
        { timeout: 10000 })
      }
    }
    // datos limpios
    const clearselection = () => {
      actplan.value = 0
      actperiodo.value = 0
      selectAlumno.value = {}
      flagactivarmod.value = false
      materias.value = []
      idsarray.value = []
    }

    // proceder la activacion
    const activarCuatrimestre = () => {
      if (actplan.value <= 0 || actperiodo.value <= 0 || selectAlumno.value.matricula <= 0) {
        toast({
          component: ToastificationContent,
          props: {
            text: 'Hey, complete los datos obligatorios',
            icon: 'AlertTriangleIcon',
            variant: 'warning',
          },
        },
        { timeout: 8000 })
      } else {
        flagproceder.value = true
        // get values for new value
        materias.value.forEach(x => idsarray.value.push(x.id_curso))
        const data = {
          action: 27,
          matricula: selectAlumno.value.matricula,
          periodo: actperiodo.value,
          plan: actplan.value,
          cursos: idsarray.value.join(','),
        }
        store.dispatch('compras/postCompras', data)
          .then(response => {
            flagproceder.value = false
            const { icon, label } = formhttp(response.status)
            toast({
              component: ToastificationContent,
              props: {
                text: response.message,
                icon,
                variant: label,
              },
            },
            { timeout: 8000 })
            if (response.status === 200) {
              cursosActivos(selectAlumno.value.matricula)
              clearselection()
              // is there
            }
          }, error => {
            flagproceder.value = false
            toast({
              component: ToastificationContent,
              props: {
                title: 'Atención',
                text: error,
                icon: 'AlertCircleIcon',
                variant: 'warning',
              },
            },
            { timeout: 10000 })
          })
      }
    }

    // Obtiene lista de Periodos por Oferta Academica.
    const selecperiodo = () => {
      // llamar API para obtener periodo
      ofertaacademica()
        .then(response => {
          flagproceder.value = false
          periodos.value = response.data
          loader.value.filters = false
        })
        .catch(error => {
          loader.value.filters = false
          errorContent.value.filters = true
          toast({
            component: ToastificationContent,
            props: {
              title: 'Error en petición [Oferta Academica]',
              text: `${error} Intente de nuevo por favor.`,
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          },
          { timeout: 10000 })
        })
    }

    // Obtiene informacion acerca del Periodo Seleccionado
    const planxperiodo = () => {
      if (actperiodo.value != null) {
        planselect(actpersonafk.value, actperiodo.value)
          .then(response => {
          // flagproceder.value = true
            materias.value = response.data.materias
            temporalidad.value = response.data.temporalidad
            isActive.value = false
          })
          .catch(error => {
            loader.value.filters = false
            errorContent.value.filters = true
            toast({
              component: ToastificationContent,
              props: {
                title: 'Atención',
                text: `${error}.`,
                icon: 'AlertCircleIcon',
                variant: 'warning',
              },
            },
            { timeout: 10000 })
          })
      } else {
        materias.value = []
        isActive.value = true
      }
    }

    const actualizarTabla = () => {
      refetchData(true)
    }
    const loadusuarios = () => {
      actualizarTabla()
    }

    //* On mounted
    onMounted(() => {
      fetchCatalogosFilters() //* Load filter options (selects)
      dynamicParamRequest.value = configRequest.value //* Asign config params for each module as dynamic params
      // cargar catalogos
    })

    watch(errorRequest, error => { if (error) errorContent.value.table = error }) //* If the flag 'errorRequest' from data request is true, hide table content
    watch(configRequest.value, () => { refetchData() }) //* Any change in config params (filters), refetch table data

    return {
      fetchData,
      tableColumns,
      perPage,
      currentPage,
      totalItems,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refDataListTable,
      refetchData,
      // Filter
      lastUpdate,
      updatedAt,
      timestampToDate,
      nombreModalidad,
      avatarText,
      isActive,
      loadusuarios,
      // Filter's option
      rolOptions,
      grupoOptions,
      statusOptions,
      // Extra Filters
      configRequest,

      // UI
      resolveUserestadoVariant,
      resolveUserrolVariant,
      resolveUserGrupoVariant,
      resolveUserrolIcon,

      // Loader - flags
      loader,
      isBusyTable,
      flagactivarmod,
      flagproceder,

      // Datos
      selectAlumno,
      kardexActual,
      planes,
      periodos,
      actplan,
      actperiodo,
      actpersonafk,
      materias,
      temporalidad,
      idplan,
      // Error
      errorContent,
      // functions
      documentActive,
      activarCuatrimestre,
      moodActive,
      clearselection,
      selecperiodo,
      ofertaacademica,
      planselect,
      planxperiodo,
    }
  },
}
</script>
